import { useState, useMemo } from 'react';

type AsyncActionFn = (...args: any[]) => Promise<any>;

export function useAsyncAction<T extends AsyncActionFn>(
  action: T,
  deps: any[] = []
): [(...args: Parameters<T>) => void, boolean] {
  const [loading, setLoading] = useState(false);

  const run = useMemo(
    () => (...args: Parameters<T>) => {
      if (loading) {
        return;
      }

      setLoading(true);

      action(...args).then(() => {
        setLoading(false);
      });
    },
    [loading, setLoading, ...deps]
  );

  return useMemo(() => [run, loading], [run, loading]);
}
